import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "audio"];
  static values = { basePath: String, prefix: String };

  connect() {
    this.update();
  }

  update() {
    const model = this.selectTarget.value;
    this.audioTarget.src = `${this.basePathValue}/${this.prefixValue}${model}.mp3`;
    this.audioTarget.load();
  }
}
